import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useMemo, useState } from 'react';

var sortImages = function sortImages() {
  var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return images.filter(function (_ref) {
    var disabled = _ref.disabled;
    return !disabled;
  }).sort(function (a, b) {
    return a.position - b.position;
  });
};
/**
 * A hook for interacting with the state of a carousel of images.
 *
 * @param {Array} images an array of image objects
 * @param {number} startIndex the index at which to start the carousel
 */


export var useCarousel = function useCarousel() {
  var images = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _useState = useState(startIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeItemIndex = _useState2[0],
      setActiveItemIndex = _useState2[1];

  var sortedImages = useMemo(function () {
    return sortImages(images);
  }, [images]);
  var handlePrevious = useCallback(function () {
    // If we're on the first image we want to go to the last.
    setActiveItemIndex(function (prevIndex) {
      if (prevIndex > 0) {
        return prevIndex - 1;
      } else {
        return images.length - 1;
      }
    });
  }, [images]);
  var handleNext = useCallback(function () {
    // If we're on the last image we want to go to the first.
    setActiveItemIndex(function (prevIndex) {
      return (prevIndex + 1) % images.length;
    });
  }, [images]);
  var api = useMemo(function () {
    return {
      handlePrevious: handlePrevious,
      handleNext: handleNext,
      setActiveItemIndex: setActiveItemIndex
    };
  }, [handlePrevious, handleNext, setActiveItemIndex]);
  var state = {
    activeItemIndex: activeItemIndex,
    sortedImages: sortedImages
  };
  return [state, api];
};